export const TIP_OTPADA = {
  mjesoviti: { name: 'Mješoviti otpad', color: 'gray-400' },
  papirKarton: { name: 'Papir i karton', color: 'darkBlue' },
  ambalazni: { name: 'Ambalažni otpad', color: 'darkYellow' },
  stakleni: { name: 'Stakleni otpad', color: 'green-400' },
};
